import { Injectable } from '@angular/core';
import {ServerService} from "./ServerService";
import {HttpClient} from "@angular/common/http";
import {BehaviorSubject, Observable} from "rxjs";
import { first, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ConfiguracoesMiaService extends ServerService {
  private configuracoesSubject: BehaviorSubject<any>;
  private configuracoesLoaded: boolean = false;

  constructor(private httpCliente: HttpClient) {
    super(httpCliente);

    this.configuracoesSubject = new BehaviorSubject<any>(null);

    window.addEventListener('storage', this.detectarMudancasLocalStorage.bind(this));
  }

  async salveConfiguracoes(configuracoes: any) {
    localStorage.setItem('alterouConfiguracoesMia', new Date().getTime().toString());

    return this.salve('/configuracoesMia', configuracoes);
  }

  async atualizeMudouPlano(configuracoes: any) {
    localStorage.setItem('atualizeMudouPlano', new Date().getTime().toString());

    return this.facaPost('/configuracoesMia/atualizeMudouPlano', configuracoes);
  }

  // Observable para as configurações
  get configuracoes$(): Observable<any> {
    return this.configuracoesSubject.asObservable().pipe(
      tap(() => {
        if (!this.configuracoesLoaded) {
          this.carregarConfiguracoes();
        }
      })
    );
  }

  public  async obtenhaConfiguracoes() {
    return this.obtenha('/configuracoesMia', {});
  }

  /** Status do canal da Mia V3 para a loja; checklist completo para administradores. */
  public async obtenhaStatusMiaV3() {
    return this.obtenha('/configuracoesMia/statusMiaV3', {});
  }

  /** Cards dos itens do upsell (nome, preço, imagem, elegibilidade). Sem ids, usa os salvos. */
  public async obtenhaItensUpsell(ids: number[] = null) {
    const query: any = {};
    if (ids && ids.length) query.ids = ids.join(',');
    return this.obtenha('/configuracoesMia/upsellItens', query);
  }

  public crieFluxosTypebotPadrao() {
    return this.facaPost('/configuracoesMia/crieFluxosTypebotPadrao', {});
  }

  public obtenhaModoNotificacaoPedido() {
    return this.obtenha('/configuracoesMia/modo-notificacao-pedido', {});
  }

  public async atualizeModoNotificacaoPedido(modo: 'unica' | 'por_status' | null) {
    localStorage.setItem('alterouConfiguracoesMia', new Date().getTime().toString());

    const response = await this.facaPost('/configuracoesMia/modo-notificacao-pedido', { modo });
    await this.carregarConfiguracoes();
    return response;
  }

  // várias telas/componentes assinam configuracoes$ ao mesmo tempo (ex.: badge de
  // origem em cada linha do grid de pedidos) — sem o guard cada assinante disparava
  // uma requisição própria antes da primeira resposta chegar
  private carregamentoEmAndamento: Promise<void> = null;

  private async carregarConfiguracoes() {
    if (this.carregamentoEmAndamento) return this.carregamentoEmAndamento;

    this.carregamentoEmAndamento = (async () => {
      const configuracoes = await this.obtenha('/configuracoesMia', {});
      this.configuracoesSubject.next(configuracoes);
      this.configuracoesLoaded = true;
    })().finally(() => {
      this.carregamentoEmAndamento = null;
    });

    return this.carregamentoEmAndamento;
  }

  private detectarMudancasLocalStorage(event: StorageEvent) {
    if (event.key === 'alterouConfiguracoesMia') {
      this.carregarConfiguracoes(); // Recarrega as configurações atualizadas
    }
  }

  public publicarFluxo(idFluxo: string) {
    return this.facaPost('/configuracoesMia/publicarFluxo', {idFluxo}).then((response: any) => {
      // After successful publication, update the configurations
      this.carregarConfiguracoes();
      return response;
    });
  }
}
